var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddModifyNomineeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0835 11.125L17.2502 11.9584L15.5418 10.25L16.3752 9.41671C16.5502 9.24171 16.8418 9.24171 17.0168 9.41671L18.0835 10.4834C18.2585 10.6584 18.2585 10.95 18.0835 11.125ZM10.0002 15.7834L15.0502 10.7334L16.7585 12.4417L11.7168 17.5H10.0002V15.7834ZM10.0002 11.6667C6.31683 11.6667 3.3335 13.1584 3.3335 15V16.6667H8.3335V15.0917L11.6668 11.7584C11.1168 11.6917 10.5585 11.6667 10.0002 11.6667ZM10.0002 3.33337C9.11611 3.33337 8.26826 3.68456 7.64314 4.30968C7.01802 4.93481 6.66683 5.78265 6.66683 6.66671C6.66683 7.55076 7.01802 8.39861 7.64314 9.02373C8.26826 9.64885 9.11611 10 10.0002 10C10.8842 10 11.7321 9.64885 12.3572 9.02373C12.9823 8.39861 13.3335 7.55076 13.3335 6.66671C13.3335 5.78265 12.9823 4.93481 12.3572 4.30968C11.7321 3.68456 10.8842 3.33337 10.0002 3.33337Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddModifyNomineeIcon);
export default __webpack_public_path__ + "static/media/add-modify-nominee-icon.d18706949c764bf101aed579dc341f42.svg";
export { ForwardRef as ReactComponent };